import React from 'react';
import { StreamingOverviewResponse } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../../common/types';
import { PeriodSectionGateView } from '../../period/PeriodSectionGateView';
import { audienceMessages as messages } from '../../audienceMessages';
import { AudienceBody } from './AudienceBody';

interface AudienceSectionProps {
  accountId: number;
  overview: StreamingOverviewResponse;
  onOpenCatalog: () => void;
}

/** Streaming → Audience (design streaming-sections a1-a3, e2, e4): listener gender and age per month. */
const AudienceSectionComponent: React.FC<AudienceSectionProps> = ({ accountId, overview, onOpenCatalog }) => (
  <PeriodSectionGateView
    overview={overview}
    section="audience"
    emptyTitle={messages.emptyTitle}
    emptyText={messages.emptyText}
    onOpenCatalog={onOpenCatalog}
  >
    <AudienceBody accountId={accountId} days={overview.days} />
  </PeriodSectionGateView>
);

export const AudienceSection = TypedMemo(AudienceSectionComponent);
